import React, {useEffect, useRef, useState} from 'react';
import EmojiTranslator from '../components/EmojiTranslator';
import './HomePage.css';

const LOGO_VIDEO = 'https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/Emoji%20Alchemist%20Logo%20Animation.mp4';
const LOGO_IMAGE = 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1753209561893-emoji-alchemist-logo.png';

const HomePage = () => {
  const videoRef = useRef(null);
  const [videoFailed, setVideoFailed] = useState(false);
  const [videoPlaying, setVideoPlaying] = useState(false);

  // iOS can refuse autoplay (Low Power Mode, Sleep focus, motion settings). The static logo
  // stays on top until the video actually plays; if the video can't load, it stays for good.
  // (A video poster can't be used: the PNG is cropped tighter than the video frame, so inside
  // the trimmed, feathered video box it rendered oversized and ran into the headline.)
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    const attempt = video.play();
    if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
  }, []);

  return (
    <div className="ea-page">
      {/* Calm logo zone: flat background so the logo video's edges disappear. */}
      <header className="ea-hero">
        <div className={`ea-logo-wrap${videoPlaying ? ' is-playing' : ''}`}>
          {videoFailed ? (
            <img src={LOGO_IMAGE} className="ea-logo" alt="Emoji Alchemist" />
          ) : (
            <video
              ref={videoRef}
              src={LOGO_VIDEO}
              className="ea-logo"
              autoPlay
              loop
              muted
              playsInline
              preload="auto"
              disablePictureInPicture
              onError={() => setVideoFailed(true)}
              onPlaying={() => setVideoPlaying(true)}
              aria-label="Emoji Alchemist animated logo"
            />
          )}
          {!videoFailed && (
            <img src={LOGO_IMAGE} className="ea-logo-still" alt="" aria-hidden="true" />
          )}
        </div>
        <p className="ea-eyebrow">Emoji language lab</p>
        <h1 className="ea-title">Say it your way.</h1>
        <p className="ea-subtitle">
          <span className="ea-subtitle-long">Turn everyday thoughts into expressive emoji stories with a dialect that feels like you.</span>
          <span className="ea-subtitle-short">Turn everyday thoughts into emoji stories.</span>
        </p>
      </header>

      {/* Glass zone: soft color blobs from the logo palette sit behind the translator only. */}
      <section className="ea-stage" aria-label="Emoji translator">
        <div className="ea-blobs" aria-hidden="true">
          <span className="ea-blob ea-blob-blue" />
          <span className="ea-blob ea-blob-purple" />
          <span className="ea-blob ea-blob-gold" />
          <span className="ea-blob ea-blob-pink" />
        </div>
        <EmojiTranslator />
      </section>
    </div>
  );
};

export default HomePage;